// extracted by mini-css-extract-plugin
export default {"cls1":"lQWl_gOM3vKVZrTUnpGi","cls2":"rfIElD6xSA3Txc9EGL2P lQWl_gOM3vKVZrTUnpGi"};